import React from 'react'
import { useWizard, useOnboarding } from '../context'
import { OptionCard } from './OptionCard'

export const SingleAnswer = ({
  className,
  advanceTo,
  question,
  surveyKey: key,
  icon,
  text,
  value,
  onClick,
  disableAutoNext = false
}) => {
  const { goToNextStep } = useWizard()
  const { state, updateState } = useOnboarding()

  function handleSelection() {
    const survey = state.survey
    survey[key] = [{ question: question, label: text, value: value }]
    updateState({ survey })

    onClick?.()

    if (advanceTo) {
      updateState({ role: advanceTo })
      return
    }

    if (disableAutoNext) return

    goToNextStep()
  }

  return (
    <OptionCard
      className={className}
      icon={icon}
      text={text}
      onSelection={handleSelection}
    />
  )
}
